<p>
  payment-account-activity-config-base works!
</p>
